/**
 * Copyright (c) 2023, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
 *
 * WSO2 LLC. licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import { Card, CardContent, Container, Grid, Paper, Typography } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import Uptime from "../Components/Uptime";

/**
 * OverallUptime component
 * Description: This component is used to display the overall uptime
 */
function OverallUptime({ uptime }) {
  // If uptime is undefined or empty, return an empty fragment
  if (uptime === undefined || uptime.length === 0) {
    return <></>;
  }

  return (
    <Container sx={ { my: 4 } }>
      <Card variant="outlined" sx={ { my: 2 } }>
        <CardContent>
          <Paper elevation={ 0 }>
            <Typography component="div" sx={ { fontWeight: "bolder",pb: 2  } }>
              Overall Uptime
            </Typography>
            <Grid container>
              { uptime.map((item, index) => (
                <Uptime key={ index } availability={ item.availability } duration={ item.duration } />
              )) }
            </Grid>
          </Paper>
        </CardContent>
      </Card>
    </Container>
  );
}

OverallUptime.propTypes = {
  uptime: PropTypes.array
};

export default OverallUptime;
